import {Errors, KAError, type ErrorKind} from "@khan/logging";

import {ERROR_CODE_INTERNAL, ERROR_CODE_INVALID_INPUT} from "../constants.ts";

export function khanmigoStreamErrorToJsonError(errorResponseText: string): {
    error: string;
    reason?: string;
} {
    try {
        return JSON.parse(errorResponseText);
    } catch {
        return {
            error: ERROR_CODE_INTERNAL,
            reason: errorResponseText,
        };
    }
}

/* Takes a JSON error and converts it into a more useful KAError
 */
export function khanmigoJsonErrorToKAError(json: {
    error?: string;
    reason?: string;
}): KAError | undefined {
    let kind: ErrorKind;
    switch (json.error) {
        case ERROR_CODE_INVALID_INPUT:
            kind = Errors.InvalidInput;
            break;
        case ERROR_CODE_INTERNAL:
            kind = Errors.Internal;
            break;
        default:
            return undefined;
    }

    return new KAError(json.reason ?? "", kind);
}
